import { useEffect, useRef, useState } from "react";

// From: https://stackoverflow.com/a/61719846
/**
 * Check if an element is in viewport

 * @param {number} offset - Number of pixels up to the observable element from the top
 */
export default function useVisibility<Element extends HTMLElement>(
  offset = 0,
): [boolean, React.RefObject<Element | null>] {
  const [isVisible, setIsVisible] = useState(false);
  const currentElement = useRef<Element>(null);

  useEffect(() => {
    const el = currentElement.current;
    if (!el) return;

    const observer = new window.IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      {
        root: null,
        rootMargin: `${offset}px 0px ${offset}px 0px`,
        threshold: 0,
      },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [offset]);

  return [isVisible, currentElement];
}
